import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--mode-border-neutral-weakest);
  border-radius: var(--box-wrapper-section-border-radius);
  margin-bottom: 32px;
`;

export const Header = styled.div`
  padding-top: 20px;
  padding-bottom: -32px;
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  @media (min-width: ${breakpoints[2]}) {
    padding-right: 24px;
  }
`;

export const GridHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr repeat(2, 1fr) 0.7fr;
  gap: 24px;
  padding-top: 20px;
  padding-left: 24px;

  @media (min-width: ${breakpoints[2]}) {
    padding-right: 24px;
  }

  & > *:last-child {
    margin-left: auto;
  }
`;

export const Row = styled(Header)<{ $shouldForceLessSpacing?: boolean }>`
  margin-bottom: ${props =>
    props.$shouldForceLessSpacing ? "-32px !important" : "16px"};
  padding-top: 16px;
  padding-left: 24px;
  padding-right: 24px;
`;

export const GridRow = styled(Header)<{ $shouldForceLessSpacing?: boolean }>`
  margin-bottom: ${props =>
    props.$shouldForceLessSpacing ? "-32px !important" : "16px"};
  padding-top: 16px;
  padding-left: 24px;
  padding-right: 24px;

  display: grid;
  grid-template-columns: 1.2fr repeat(2, 1fr) 0.7fr;
  gap: 24px;

  & > *:last-child {
    margin-left: auto;
  }
`;
